module.exports = __webpack_public_path__ + "img/RV.6585510b.png";